const container = {};
const containerFacade = {
  register: (key, obj) => {
    container[key] = obj;
  },
  get: key => {
    return container[key];
  },
};

module.exports = containerFacade;
